<template>
  <div class="section">
    <el-collapse v-model="expandedItems">
      <el-collapse-item title="Identificação" name="1">
        <div class="section double-column">
          <div class="info2">
            <h4>Dados pessoais</h4>
            <p><strong>Nome:</strong> {{ solicitante.nome }}</p>
            <p>
              <strong>CPF:</strong>
              {{ formatarDocumento(solicitante.cpf || solicitante.passaporte) }}
            </p>
            <p>
              <strong>Sexo:</strong>
              {{ solicitante.sexo === 0 ? "Masculino" : "Feminino" }}
            </p>
            <p>
              <strong>Data de nascimento:</strong>
              {{ solicitante.dataNascimentoString }}
            </p>
            <p><strong>Nome da Mãe:</strong> {{ solicitante.nomeMae }}</p>
          </div>
          <div class="info2">
            <h4>Endereço principal</h4>
            <p>
              <strong>CEP:</strong>
              {{ formatarCEP(solicitante.enderecoPrincipal.cep) }}
            </p>
            <p>
              <strong>Logradouro:</strong>
              {{ solicitante.enderecoPrincipal.logradouro }}
            </p>
            <p>
              <strong>Bairro:</strong>
              {{ solicitante.enderecoPrincipal.bairro }}
            </p>
            <p>
              <strong>Município:</strong>
              {{
                solicitante.enderecoPrincipal.municipio &&
                  solicitante.enderecoPrincipal.municipio.nome
              }}
            </p>
            <p>
              <strong>UF:</strong>
              {{
                solicitante.enderecoPrincipal.municipio &&
                  solicitante.enderecoPrincipal.municipio.estado.nome
              }}
            </p>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Informações complementares" name="2">
        <div class="info2 padding">
          <p>
            Modalidade de pesca:
            <strong>{{
              (function() {
                const modalidadeSelecionada = listaOpcoes.modalidadesPesca.find(
                  modalidade =>
                    modalidade.cod === informacoesComplementares.modalidadePesca
                );
                return modalidadeSelecionada
                  ? modalidadeSelecionada.descricao_pt
                  : "Não informado";
              })()
            }}</strong>
          </p>
          <p>
            Valor a pagar:
            <strong>
              R$
              {{
                calcularPreco(informacoesComplementares.modalidadePesca)
              }}</strong
            >
          </p>
          <p class="info2 small-text">
            Validade da carteira: 02 anos
          </p>
          <p>
            Em média quantos dias por ano costuma pescar:
            <strong>{{ informacoesComplementares.diasPescaPorAno }}</strong>
          </p>
          <p>
            Qual peixe você costuma pescar:
            <span>
              <strong>
                {{
                  Array.isArray(informacoesComplementares.peixeMaisPescado)
                    ? informacoesComplementares.peixeMaisPescado
                        .map(cod => {
                          const peixeSelecionado = listaOpcoes.peixesMaisPescados.find(
                            peixe => peixe.cod === cod
                          );
                          return peixeSelecionado
                            ? peixeSelecionado.descricao_pt
                            : "Não informado";
                        })
                        .join(", ")
                    : (() => {
                        const peixeSelecionado = listaOpcoes.peixesMaisPescados.find(
                          peixe =>
                            peixe.cod ===
                            informacoesComplementares.peixeMaisPescado
                        );
                        return peixeSelecionado
                          ? peixeSelecionado.descricao_pt
                          : "Não informado";
                      })()
                }}
              </strong>
            </span>
          </p>
          <p>
            Equipamentos utilizados:
            <strong>{{
              informacoesComplementares.equipamentos.join(", ")
            }}</strong>
          </p>
          <p>
            Tipo de isca utilizada:
            <strong>{{
              (function() {
                const tipoIscaSelecionado = listaOpcoes.tiposIsca.find(
                  tipo => tipo.cod === informacoesComplementares.tipoIsca
                );
                return tipoIscaSelecionado
                  ? tipoIscaSelecionado.descricao_pt
                  : "Não informado";
              })()
            }}</strong>
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="actions">
      <el-button class="green-border" @click="$emit('voltar')"
        >Voltar</el-button
      >
      <el-button type="primary" @click="$emit('confirmar')"
        >Confirmar</el-button
      >
    </div>
  </div>
</template>

<script>
import { calcularPreco } from "@/utils/calculoPreco";
import {
  formatarDocumento,
  formatarCEP
} from "@/utils/layout/mascarasFormat.js";

export default {
  name: "ResumoCadastro",
  props: {
    solicitante: Object,
    informacoesComplementares: Object,
    listaOpcoes: Object
  },
  data() {
    return {
      expandedItems: ["1", "2"]
    };
  },
  methods: {
    calcularPreco,
    formatarDocumento,
    formatarCEP
  }
};
</script>

<style>
.el-collapse-item__header {
  line-height: normal !important;
}
</style>

<style scoped>
/* Estilos específicos para o componente */
.section {
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 8px;
}

.double-column {
  display: flex;
  flex-direction: row;
  gap: 10rem;
}

.info2 {
  margin: 10px 0;
}

.info2.padding {
  padding: 10px;
}

.small-text {
  font-size: 12px;
  margin-bottom: 15px;
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}

.el-button.green-border {
  border-radius: 20px;
  padding: 10px 40px !important;
}

.el-button--primary {
  background-color: #00c254;
  color: #fff;
  border-radius: 20px !important;
  font-size: 14px;
  padding: 10px 40px !important;
}

@media (max-width: 768px) {
  .double-column {
    flex-direction: column;
    gap: 2rem;
  }

  .info2 {
    margin: 10px 0;
    padding: 0 10px;
  }

  .actions {
    flex-direction: column;
    gap: 10px;
  }

  .el-button.green-border,
  .el-button--primary {
    width: 100%;
    padding: 10px !important;
  }
}
</style>
